<div class="mar">

  <div class="row ">

    <div class="col-md-8 heart">

      <form [formGroup]="predictForm" (ngSubmit)="submit()">
      <mat-card>
        <mat-card-title class="head">Are You Suffer from Heart disease??????</mat-card-title>
        <mat-card-subtitle>Fill following Credentials to know</mat-card-subtitle>
        <mat-card-content>
          <div class="row">
              <div class="col-sm-6">

                <mat-form-field>
                  <mat-label>Gender</mat-label>
                  <mat-select formControlName="sex">
                    <mat-option *ngFor="let g of gen; let i=index" [value]="i+1">
                      {{g}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="predictForm.get('sex').errors">
                    Gender is <strong>required</strong>
                  </mat-error>
                </mat-form-field><br/>

                <mat-form-field>
                  <mat-label>trestbps</mat-label>
                  <input type="number" matInput formControlName="thestbps">
                  <mat-error *ngIf="predictForm.get('thestbps').errors">
                    Trestbps should be from <strong>50 to 250.</strong>
                  </mat-error>
                </mat-form-field><br/>

                <mat-form-field>
                  <mat-label>chol</mat-label>
                  <input type="number" matInput formControlName="chol">
                  <mat-error *ngIf="predictForm.get('chol').errors">
                    Chol should be from <strong>100 to 650.</strong>
                  </mat-error>
                </mat-form-field><br/>

                <mat-form-field>
                  <mat-label>fbs</mat-label>
                  <mat-select formControlName="fbs">
                    <mat-option *ngFor="let g of fbsa" [value]="g">
                      {{g}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="predictForm.get('fbs').errors">
                    Fbs is <strong>required</strong>
                  </mat-error>
                </mat-form-field><br/>


                <mat-form-field>
                  <mat-label>Chest Pain Type(cp)</mat-label>
                  <mat-select formControlName="cp">
                    <mat-option *ngFor="let g of cpt" [value]="g">
                      {{g}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="predictForm.get('cp').errors">
                    CP is <strong>required</strong>
                  </mat-error>
                </mat-form-field><br/>

                <mat-form-field>
                  <mat-label>Restecg</mat-label>
                  <mat-select formControlName="restecg">
                    <mat-option *ngFor="let g of restecga" [value]="g">
                      {{g}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="predictForm.get('restecg').errors">
                    Restecg is <strong>required</strong>
                  </mat-error>
                </mat-form-field><br/>

                <mat-form-field>
                  <mat-label>Age</mat-label>
                  <input type="number" matInput formControlName="age">
                  <mat-hint>Should be in between 15 to 100</mat-hint>
                  <mat-error *ngIf="predictForm.get('age').errors">
                    Age should be from <strong>15 to 100</strong>
                  </mat-error>
                </mat-form-field><br/>

              </div>

              <div class=col-sm-6>
                <mat-form-field>
                  <mat-label>Thalach</mat-label>
                  <input type="number" matInput formControlName="thalach">
                  <mat-hint>Maximum heart rate achieved</mat-hint>
                  <mat-error *ngIf="predictForm.get('thalach').errors">
                    Thalach should be from <strong>40 to 400.</strong>
                  </mat-error>
                </mat-form-field><br/>

                <mat-form-field>
                  <mat-label>exang</mat-label>
                  <mat-select formControlName="exang">
                    <mat-option *ngFor="let g of fbsa" [value]="g">
                      {{g}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="predictForm.get('exang').errors">
                    Exang is <strong>required</strong>
                  </mat-error>
                </mat-form-field><br/>

                <mat-form-field>
                  <mat-label>Old Peak</mat-label>
                  <input type="number" matInput formControlName="oldpeak">
                  <mat-error *ngIf="predictForm.get('oldpeak').errors">
                    Old peak should be from <strong>0 to 10</strong>
                  </mat-error>
                </mat-form-field><br/>

                <mat-form-field>
                  <mat-label>Slope</mat-label>
                  <mat-select formControlName="slope">
                    <mat-option *ngFor="let g of restecga" [value]="g">
                      {{g}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="predictForm.get('slope').errors">
                    Slope is <strong>required</strong>
                  </mat-error>
                </mat-form-field><br/>

                <mat-form-field>
                  <mat-label>CA</mat-label>
                  <mat-select formControlName="ca">
                    <mat-option *ngFor="let g of caa" [value]="g">
                      {{g}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="predictForm.get('ca').errors">
                    CA is <strong>required</strong>
                  </mat-error>
                </mat-form-field><br/>

                <mat-form-field>
                  <mat-label>Thal(Defect type)</mat-label>
                  <mat-select formControlName="thal">
                    <mat-option *ngFor="let g of cpt" [value]="g">
                      {{g}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="predictForm.get('thal').errors">
                    Thal is <strong>required</strong>
                  </mat-error>
                </mat-form-field><br/>
              </div>
            </div>
        </mat-card-content>
        <mat-card-footer m-5 p-3>
          <button type="submit" [disabled]="!predictForm.valid" mat-button>Predict</button>
          <button type="reset" mat-button>Reset</button>
        </mat-card-footer>
      </mat-card>
      </form>

    </div>



    <div class="col-md-4">
      <h1 class="heart">Tips For You</h1>

      <div class="row">
        <div class="col-sm-3 m-1">
          <button mat-raised-button
            matTooltip="Chest-pain type displays the type of chest-pain:- "
            matTooltipPosition="above">
            CP
          </button>
        </div>
        <div class="col-sm-3 m-1">
          <button mat-raised-button
            matTooltip="Resting Blood Pressure: displays the resting blood pressure value of an individual in mmHg (unit)"
            matTooltipPosition="above">
            Trestbps
          </button>
        </div>
        <div class="col-sm-3 m-1">
          <button mat-raised-button
            matTooltip="Serum Cholestrol:displays the serum cholesterol in mg/dl (unit)"
            matTooltipPosition="above">
            Chol
          </button>
        </div>
        <div class="col-sm-3 m-1">
          <button mat-raised-button
            matTooltip="Exercise induced angina:- 0-no, 1-yes"
            matTooltipPosition="above">
            exang
          </button>
        </div>
      </div>
        <div class="row">
          <div class="col-sm-3 m-1">
            <button mat-raised-button
            matTooltip="Old Peak: ST depression induced by exercise relative to rest"
            matTooltipPosition="below">
            OldPeak
            </button>
          </div>
          <div class="col-sm-3 m-1">
            <button mat-raised-button
            matTooltip="CA: number of major vessels (0-3) colored by flourosopy"
            matTooltipPosition="below">CA
            </button>
          </div>

          <div class="col-sm-3 m-1">
            <button mat-raised-button
            matTooltip="Fasting Blood Sugar:compares the fasting blood sugar value of an individual with 120mg/dl, If fbs > 120mg/dl then : 1 (true), else 0(false). "
            matTooltipPosition="below">fbs
            </button>
          </div>
        </div>



      <ul style="text-align:left">
        <li>
          cp
          <ul style="text-align:left">
            <li>typical angina </li>
            <li>typical angina </li>
            <li>non-anginal pain</li>
            <li>asymptotic</li>
          </ul>
        </li>
        <li>(restecg)Resting ECG:displays resting electrocardiographic results
        <ul>
          <li>0=normal</li>
          <li>1=having ST-T wave abnormality</li>
          <li>2=left ventricular hyperthrophy</li>
        </ul>
        </li>
        <li>slope:the slope of the peak exercise ST segment
          <ul>
            <li>Value 0: upsloping</li>
            <li>Value 1: flat</li>
            <li>Value 2: downsloping</li>
          </ul>
        </li>
      </ul>
    </div>

  </div>
</div>
